import gql from 'graphql-tag'
import { get } from 'lodash'

import { apolloClientPrivate } from '../graphql/apolloClient'

// TODO move into a gql file and use the generated query
export default async (groupId: number, userId: number) => {
  const mutation = gql`
    mutation userRemoveFromGroup(
      $groupId: PositiveInt!
      $userId: PositiveInt!
    ) {
      admin {
        user(id: $userId) {
          id
          removeFromGroup(groupId: $groupId) {
            groups {
              id
            }
          }
        }
      }
    }
  `

  const response = await apolloClientPrivate.mutate<{
    admin: {
      user: {
        removeFromGroup: any
      }
    }
  }>({
    mutation,
    variables: {
      groupId,
      userId
    }
  })

  return get(response, 'data.admin')
}
